import {CommonModule} from '@angular/common';
import {Component, inject} from '@angular/core';
import {Router} from '@angular/router';
import {ButtonType, CovButtonComponent, CovIconComponent, IconName} from '@cov/ui-angular';
import {take} from 'rxjs';
import {CartService} from '../../services/cart.service';
import {CART} from '../../constants';

@Component({
  selector: 'cov-cart-display',
  imports: [CommonModule, CovButtonComponent, CovIconComponent],
  templateUrl: './cart-display.component.html',
  styleUrl: './cart-display.component.scss',
})
export class CartDisplayComponent {
  protected readonly ButtonType = ButtonType;
  protected readonly IconName = IconName;

  // SERVICE
  protected cartService = inject(CartService);
  protected router = inject(Router);

  // STATE
  public numberOfItems$ = this.cartService.getNumberOfItems();

  goToCart() {
    this.cartService
      .hasActiveCart()
      .pipe(take(1))
      .subscribe((active) => {
        if (active) {
          this.router.navigate([CART]);
        } else {
          // TODO: open sold to ship to selection
        }
      });
  }
}
